import React from 'react'
import ForgotPasswordPage from './ForgotPassword'

const ForgotPassword = () => (
  <ForgotPasswordPage/>
)

export default ForgotPassword
